import axios from 'axios';
import store from '../../redux/store';
import myUserSlice from '../../redux/myUserSlice';
import handleRequest from './handleRequest';
import { parseJwt } from '../../helper/Converters';
let requestPromise: any = null;
let waitingPromises: any[] = [];
const handleRefreshToken = async () => {


    const url = `${process.env.REACT_APP_API_URL}/sso/refreshMyToken`
    const refreshToken = localStorage.getItem("refreshToken")
    const defaultError = { error: true, data: { message: "error" } }
    if (!refreshToken) return defaultError
    const method: "post" | "get" | "patch" = "post"
    const data = {
        refreshToken
    }
    const showPreLoader = true
    const responseData = { method, url, data, showPreLoader }
    if (requestPromise) {
        return new Promise((resolve, reject) => {
            waitingPromises.push({ resolve, reject });
        });
    }

    // Create a new promise for the request
    requestPromise = new Promise(async (resolve, reject) => {
        try {
            const response = await handleRequest(responseData);
            const data = response;
            // Resolve all waiting promises with the same data
            waitingPromises.forEach(({ resolve }) => resolve(data));
            resolve(response)
        } catch (error) {
            // Reject all waiting promises with the same error
            waitingPromises.forEach(({ reject }) => reject(defaultError));
            localStorage.clear()
            window.location.href = "/login"
            reject(error)
        } finally {
            // Clear the waiting promises array
            waitingPromises = [];

            // Reset the requestPromise
            requestPromise = null;
        }
    });

    return requestPromise;

};

export default handleRefreshToken;


